import { Layout, Row } from 'antd';
import { SaveAndExitHeader } from 'components/header';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { push } from 'connected-react-router';
import { PatientRoutes } from 'routes';

import './questionnaire-completion.scss';

import {
  BaseButton,
  QuestionnaireGreyButton
} from 'components/button/button-base';
import Flower from 'img/flower.svg';
import { getPatientLinkUrl } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import { useParams } from 'react-router-dom';
import { TakeABreakFilter } from '../assessment-controller/_components/take-a-break-filter';
import { CompletionProps } from './questionnaire-completion-promis';

const config = {
  defaultDescription: `Great work completing all the questionnaires. Next up is the neurocognitive screening, which will take at least 20 minutes. Take a break if you need it. If you're ready click the button to continue. `,
  defaultImage: Flower
};

/**
 * This component renders after a questionnaire is done
 */
export function QuestionnaireCompletionEnd(props: CompletionProps) {
  const { patientId } = useParams<{ patientId: string }>();
  const dispatch = useDispatch();

  const [showBreak, setBreak] = useState(false);
  const continueLink = getPatientLinkUrl(
    PatientRoutes.AssessmentControlFlow,
    patientId
  );
  function handleOnContinue() {
    dispatch(push(continueLink));
  }
  function takeBreak() {
    setBreak(prev => !prev);
  }
  return (
    <>
      {showBreak && <TakeABreakFilter onContinue={handleOnContinue} />}

      <Layout className="layout-container">
        <SaveAndExitHeader
          title={'All Questionnaires Completed'}
          label={'Save & Exit'}
          onExit={() => dispatch(push('/'))}
        />

        <Row>
          <div
            style={{
              display: 'flex',
              flex: '1',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              marginLeft: '120px'
            }}
          >
            {/* <ConnectedOutcomeMeasuresProgressBar label size={['100%', 18]} /> */}
            <div style={{ maxWidth: '600px', marginBottom: '60px' }}>
              <p className="completion-title">Almost there!</p>
              <p className="completion-description">
                {props.description ?? config.defaultDescription}
              </p>
            </div>
            <div>
              <div style={{ paddingBottom: '24px' }}>
                <QuestionnaireGreyButton
                  // minHeight={60}
                  // minWidth={150}
                  // label={'I need a break'}
                  // rounded={true}
                  // baseFont={true}
                  // iconBefore={false}
                  icon={null}
                  onClick={takeBreak}
                  style={{ fontSize: 20 }}
                >
                  I need a break
                </QuestionnaireGreyButton>
              </div>
              <BaseButton href={continueLink} style={{ fontSize: 20 }}>
                Continue
              </BaseButton>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flex: '1',
              flexDirection: 'column',
              maxHeight: '100dvh'
            }}
          >
            <img
              src={props.img ?? config.defaultImage}
              className="completion-img"
            />
          </div>
        </Row>
      </Layout>
    </>
  );
}
